module.exports = __webpack_public_path__ + "img/illo_3.1a83288d.svg";